import React from 'react'

import { useTranslation } from 'react-i18next'

import Divider from '@layout/Divider'
import SideNavItem from '@layout/SideNavMenu/SideNavItem'
import { useSession } from '@stores/globalData/globalData.store'
import PageRoutes from '@utils/page-routes'

const RecentScoresNav: React.FC = () => {
  const { t } = useTranslation()
  const session = useSession()

  if (!session.current_user || !session.visited_scores?.length) return null
  return (
    <>
      <Divider />
      <p className="font-medium text-base ml-2 mb-2">{t('siteSidebar.recentScores')}</p>
      {session.visited_scores.map((score, index) => (
        <SideNavItem
          key={`${score.external_id}-${index}`}
          href={PageRoutes.viewScorePath(score.external_id)}
          external
          label={score.title}
          iconName="nf-note"
        />
      ))}
    </>
  )
}

export default RecentScoresNav
